import { render } from "./GeographyBlog.vue?vue&type=template&id=584f1efb&scoped=true"
import script from "./GeographyBlog.vue?vue&type=script&lang=js"
export * from "./GeographyBlog.vue?vue&type=script&lang=js"

import "./GeographyBlog.vue?vue&type=style&index=0&id=584f1efb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584f1efb"]])

export default __exports__